const getEndPoint = {};

getEndPoint.get = () => {
    return process.env.NODE_ENV === 'development' ? 'http://localhost:8000/api' : 'https://backend.portal.rgsaude.com.br/api'
}

export default getEndPoint;